import React, { useState } from "react";
import SearchBar from "../components/searchbar/SearchBar";
import CardList from "../components/cardlist/CardList";
import { fetchCards } from "../api/cards"; //scryfall
import { aiQuery } from "../api/ai"; //ai
import CardProfile from "../components/cardprofile/CardProfile";
import "./Home.css";

const Home = () => {
  // states to manage cards, search query, input
  const [cards, setCards] = useState([]);
  const [input, setInput] = useState("");
  // state to manage search status and no results message
  const [hasSearched, setHasSearched] = useState(false);
  const [showNoResults, setShowNoResults] = useState(false);
  // state to manage selected card
  const [selectedCard, setSelectedCard] = useState(null);

  // function to handle search input and fetch cards
  const handleSearch = async (e) => {
    e.preventDefault();
    if (!input.trim()) return;

    setHasSearched(true);
    setShowNoResults(false);

    try {
      // ask the AI to interpret users query
      const aiQueryString = await aiQuery(input);

      if (!aiQueryString) {
        throw new Error("AI couldn't interpret the query.");
      }

      // use AI translated query to fetch cards
      const results = await fetchCards(aiQueryString);
      setCards(results);

      // handle no results
      if (results.length === 0 && hasSearched) {
        setTimeout(() => setShowNoResults(true), 100);
      }
    } catch (err) {
      console.error("Search failed:", err.message);
      setCards([]);
      setShowNoResults(true);
    }

    setInput("");
  };

  return (
    <div>
      <div className={`home-wrapper ${cards.length === 0 ? "centered" : ""}`}>
        <h1 className="page-title">MTG App</h1>
        <SearchBar input={input} setInput={setInput} onSearch={handleSearch} />
      </div>
      <CardList
        cards={cards}
        showNoResults={showNoResults}
        onCardClick={setSelectedCard}
      />
      {selectedCard && (
        <CardProfile
          card={selectedCard}
          onClose={() => setSelectedCard(null)}
        />
      )}
    </div>
  );
};

export default Home;
